import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PasswordGate from '@/components/PasswordGate';
import HomePage from '@/pages/HomePage';
import ChatPage from '@/pages/ChatPage';
import ResourcesPage from '@/pages/ResourcesPage';
import DontUseAlonePage from '@/pages/DontUseAlonePage';
import HarmReductionKitPage from '@/pages/HarmReductionKitPage';
import PartySmartPage from '@/pages/PartySmartPage';
import PSPGuidesPage from '@/pages/PSPGuidesPage';
import PSPTrainingHubPage from '@/pages/PSPTrainingHubPage';
import AboutPSPPage from '@/pages/AboutPSPPage';
import GaytionaryPage from '@/pages/GaytionaryPage';
import PostPartySelfCarePage from '@/pages/PostPartySelfCarePage';
import PnPToolkitPage from '@/pages/PnPToolkitPage';
import PSPInfoCardsPage from '@/pages/PSPInfoCardsPage';
import MythsVsFactsPage from '@/pages/MythsVsFactsPage';
import SupplementsGuidePage from '@/pages/SupplementsGuidePage';
import PartyingTonightPage from '@/pages/PartyingTonightPage';
import KnowYourSubstancePage from '@/pages/KnowYourSubstancePage';
import HydrationReminderPage from '@/pages/HydrationReminderPage';
import KnowYourGPage from '@/pages/KnowYourGPage';
import HIVSTBBIPartyingPage from '@/pages/HIVSTBBIPartyingPage';
import MoodCheckInPage from '@/pages/MoodCheckInPage';
import LivingWithHIVPage from '@/pages/LivingWithHIVPage';
import SaferUseChecklistPage from '@/pages/SaferUseChecklistPage';
import MedsReminderPage from '@/pages/MedsReminderPage';
import DrugTestingPage from '@/pages/DrugTestingPage';
import CrisisHotlines from '@/components/CrisisHotlines';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <PasswordGate>
      <div className="App">
        <div className="party-glow" />
        <div className="party-glow-2" />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/party-smart" element={<PartySmartPage />} />
            <Route path="/psp-guides" element={<PSPGuidesPage />} />
            <Route path="/psp-training" element={<PSPTrainingHubPage />} />
            <Route path="/about-psp" element={<AboutPSPPage />} />
            <Route path="/gaytionary" element={<GaytionaryPage />} />
            <Route path="/post-party-care" element={<PostPartySelfCarePage />} />
            <Route path="/pnp-toolkit" element={<PnPToolkitPage />} />
            <Route path="/psp-info-cards" element={<PSPInfoCardsPage />} />
            <Route path="/myths-vs-facts" element={<MythsVsFactsPage />} />
            <Route path="/supplements-guide" element={<SupplementsGuidePage />} />
            <Route path="/partying-tonight" element={<PartyingTonightPage />} />
            <Route path="/know-your-substance" element={<KnowYourSubstancePage />} />
            <Route path="/hydration-reminder" element={<HydrationReminderPage />} />
            <Route path="/know-your-g" element={<KnowYourGPage />} />
            <Route path="/hiv-stbbi-partying" element={<HIVSTBBIPartyingPage />} />
            <Route path="/mood-check-in" element={<MoodCheckInPage />} />
            <Route path="/living-with-hiv" element={<LivingWithHIVPage />} />
            <Route path="/safer-use-checklist" element={<SaferUseChecklistPage />} />
            <Route path="/meds-reminder" element={<MedsReminderPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/dont-use-alone" element={<DontUseAlonePage />} />
            <Route path="/drug-testing" element={<DrugTestingPage />} />
            <Route path="/harm-reduction-kit" element={<HarmReductionKitPage />} />
          </Routes>
          <CrisisHotlines />
        </BrowserRouter>
        <Toaster />
      </div>
    </PasswordGate>
  );
}

export default App;